/* eslint-disable no-restricted-syntax */
/* eslint-disable import/prefer-default-export */

import { isObject } from '../../domain/utils/utilitarios-frontend-coopeuch/object';
import { isArray } from '../../domain/utils/utilitarios-frontend-coopeuch/array';

export const saveAllEntitiesToStorage = (entitiesObject, arrayIgnoredEntities = []) => {
  for (const [key, value] of Object.entries(entitiesObject)) {
    if (!arrayIgnoredEntities.includes(key)) {
      const nameProp = key
        .split(/(?=[A-Z])/)
        .join('-')
        .toLowerCase();
      if (isObject(value.value)) {
        for (const [littleKey, littleVal] of Object.entries(value.value)) {
          sessionStorage.setItem(`${littleKey}-${nameProp}`, littleVal);
        }
      } else sessionStorage.setItem(nameProp, value.value);
    }
  }
};

export const saveAllEntitiesFromStorage = (entitiesObject, arrayIgnoredEntities = []) => {
  const arrayObjectKeysValues = [];
  for (const [key, value] of Object.entries(entitiesObject)) {
    if (!arrayIgnoredEntities.includes(key)) {
      let tempValue;
      const nameProp = key
        .split(/(?=[A-Z])/)
        .join('-')
        .toLowerCase();
      if (isObject(value.value)) {
        if (!isArray(value.value)) {
          // no aplica para un array
          tempValue = {};
          for (const [littleKey, littleValue] of Object.entries(value.value)) {
            const valueStorage = sessionStorage.getItem(`${littleKey}-${nameProp}`);
            tempValue = {
              ...tempValue,
              [littleKey]:
                typeof littleValue === 'boolean' ? valueStorage === 'true' : valueStorage,
            };
          }
        } else {
          // TODO: pendiente aplicar metodo para convertir array guardado en storage y devolverlo a array
          tempValue = [];
        }
      } else {
        const valueStorage = sessionStorage.getItem(nameProp);
        tempValue = typeof value.value === 'boolean' ? valueStorage === 'true' : valueStorage;
      }
      arrayObjectKeysValues.push({ key, value: tempValue });
    }
  }
  return arrayObjectKeysValues;
};
